/**
 * Market Selector + Weglot Integration
 * Shared JavaScript for header, footer, and mobile menu market/language selectors.
 *
 * NOTE: Automatic Weglot language syncing on market change is DISABLED.
 * The market selector uses Shopify's native localization form submission.
 * Weglot button updates still work when language is changed via Weglot.
 */
(function() {
  'use strict';

  // Maximum retries when waiting for Weglot to load
  var MAX_WEGLOT_RETRIES = 50; // 50 * 100ms = 5 seconds max wait
  var weglotRetryCount = 0;

  // Language mappings for button display
  var LANGUAGE_MAP = {
    'no': { name: 'Norsk', flag: 'no' },
    'en': { name: 'English', flag: 'gb' },
    'de': { name: 'Deutsch', flag: 'de' },
    'fr': { name: 'Français', flag: 'fr' },
    'es': { name: 'Español', flag: 'es' }
  };

  /**
   * Update a flag image element with new country code
   */
  function updateFlagImage(flagImg, flagCode) {
    if (!flagImg || !flagCode) return;
    flagImg.src = 'https://flagcdn.com/w40/' + flagCode + '.png';
    flagImg.srcset = 'https://flagcdn.com/w40/' + flagCode + '.png 1x, https://flagcdn.com/w80/' + flagCode + '.png 2x';
    flagImg.alt = flagCode.toUpperCase();
  }

  /**
   * Update language selector buttons with current Weglot language
   */
  function updateLanguageButtons(langCode) {
    var mapping = LANGUAGE_MAP[langCode];
    if (!mapping) return;

    // Update footer language button
    var footerLangButton = document.getElementById('footer-language-button');
    if (footerLangButton) {
      var footerFlagImg = footerLangButton.querySelector('.country-flag');
      updateFlagImage(footerFlagImg, mapping.flag);

      var footerTextEl = document.getElementById('footer-language-text');
      if (footerTextEl) {
        footerTextEl.textContent = mapping.name;
      }
    }

    // Update floating language button (bottom-right)
    var floatingLangButton = document.getElementById('floating-language-button');
    if (floatingLangButton) {
      var floatingFlagImg = floatingLangButton.querySelector('.country-flag');
      updateFlagImage(floatingFlagImg, mapping.flag);

      var floatingTextEl = document.getElementById('floating-language-text');
      if (floatingTextEl) {
        floatingTextEl.textContent = mapping.name;
      }
    }

    // Update aria-current on language choice items in both selectors
    document.querySelectorAll('#footer-language-selector [data-weglot-lang], #floating-language-selector [data-weglot-lang]').forEach(function(item) {
      var label = item.querySelector('.popover__choice-label');
      if (label) {
        if (item.getAttribute('data-weglot-lang') === langCode) {
          label.setAttribute('aria-current', 'true');
        } else {
          label.removeAttribute('aria-current');
        }
      }
    });
  }

  /**
   * Setup click handlers for language selector items (Weglot language switching)
   */
  function setupLanguageClickHandlers() {
    // Handle language-only selector items (anchors with data-weglot-lang)
    document.querySelectorAll('a[data-weglot-lang]').forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        var langCode = this.getAttribute('data-weglot-lang');

        // Switch language using Weglot API
        if (typeof Weglot !== 'undefined' && langCode) {
          Weglot.switchTo(langCode);
        }

        // Close popover after brief delay
        var popover = this.closest('popover-content');
        if (popover) {
          setTimeout(function() {
            popover.removeAttribute('open');
          }, 100);
        }
      });
    });
  }

  /**
   * Setup footer popover mutual exclusion (close one when other opens)
   */
  function setupFooterPopovers() {
    var footerLangButton = document.getElementById('footer-language-button');
    var footerMarketButton = document.getElementById('footer-market-button');
    var footerMarketPopover = document.getElementById('footer-market-selector');
    var footerLanguagePopover = document.getElementById('footer-language-selector');

    if (footerLangButton && footerMarketPopover) {
      footerLangButton.addEventListener('click', function() {
        footerMarketPopover.removeAttribute('open');
        if (footerMarketButton) footerMarketButton.setAttribute('aria-expanded', 'false');
      });
    }
    if (footerMarketButton && footerLanguagePopover) {
      footerMarketButton.addEventListener('click', function() {
        footerLanguagePopover.removeAttribute('open');
        if (footerLangButton) footerLangButton.setAttribute('aria-expanded', 'false');
      });
    }
  }

  /**
   * Sync button state with current Weglot language
   */
  function syncWithWeglot() {
    if (typeof Weglot !== 'undefined') {
      var currentLang = Weglot.getCurrentLang();
      if (currentLang) {
        updateLanguageButtons(currentLang);
      }
    }
  }

  /**
   * Wait for Weglot to be available and initialized
   */
  function waitForWeglot(callback) {
    if (typeof Weglot !== 'undefined') {
      if (Weglot.initialized) {
        callback();
      } else {
        Weglot.on('initialized', callback);
      }
      // Listen for language changes to update buttons
      Weglot.on('languageChanged', function(newLang) {
        updateLanguageButtons(newLang);
      });
    } else {
      weglotRetryCount++;
      if (weglotRetryCount < MAX_WEGLOT_RETRIES) {
        setTimeout(function() {
          waitForWeglot(callback);
        }, 100);
      }
    }
  }

  /**
   * Initialize the market selector functionality
   */
  function init() {
    setupFooterPopovers();
    setupLanguageClickHandlers();
    waitForWeglot(syncWithWeglot);
  }

  // Run init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
